import { REGULATED_REGION_CODES, US_COUNTRY_CODE } from './getIsUserInPriceRegulatedState.constants';

export const getIsUserInPriceRegulatedState = (countryCode?: string, regionCode?: string) =>
    countryCode === US_COUNTRY_CODE && !!regionCode && REGULATED_REGION_CODES.includes(regionCode);
